function nonEmptyStringProptype(props, propName, componentName) {
  const str = props[propName];
  if (str == null) {
    return null;
  }
  if (typeof str !== 'string') {
    return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`, ") + 'expected `string`.');
  }
  if (str.trim().length === 0) {
    return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`, ") + "`".concat(propName, "` cannot be an empty string."));
  }
  return null;
}
export default nonEmptyStringProptype;